import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { Check } from 'react-bootstrap-icons';

import useTranslation from '../../hooks/use_translation';
import SectionHeader from './sections/section-header';

const AlwaysIncluded = () => {
	const { t } = useTranslation('component_always_included');

	return (
		<div className="container">
			<div className="row align-items-center justify-content-between">
				<div className="col-xl-6 col-md-12 order-1 order-lg-2">
					<div className="mb-3 mb-xl-0">
						<StaticImage
							alt="zample app"
							className="img-fluid mb-0 mb-lg-0"
							src="../../images/how_it_works/sa_fungerar_det_zample_steg3.webp"
						/>
					</div>
				</div>
				<div className="col-xl-5 col-md-10 order-2 order-lg-1">
					<div className="row">
						<div className="col-xxl-12">
							<SectionHeader
								headingType="p"
								hideButton={true}
								size="lg"
								subHeadingType="h3"
								subTitle={t('t1')}
								title={t('t2')}
							/>
						</div>
					</div>

					<div className="mb-lg-4">
						<div className="d-flex align-items-start mb-1">
							<div className="icon-md me-2 ">
								<Check className=" text-dark" />
							</div>
							<div>
								<p className="title-small mb-0">{t('t3')}</p>
								<p className="x-small text-muted">{t('t4')}</p>
							</div>
						</div>
					</div>
					<div className="mb-lg-4">
						<div className="d-flex align-items-start mb-1">
							<div className="icon-md me-2 ">
								<Check className=" text-dark" />
							</div>
							<div>
								<p className="title-small mb-0">{t('t5')}</p>
								<p className="x-small text-muted">{t('t6')}</p>
							</div>
						</div>
					</div>
					<div className="mb-lg-4">
						<div className="d-flex align-items-start mb-1">
							<div className="icon-md me-2 ">
								<Check className=" text-dark" />
							</div>
							<div>
								<p className="title-small mb-0">{t('t7')}</p>
								<p className="x-small text-muted">{t('t8')}</p>
							</div>
						</div>
					</div>
					<div className="mb-lg-4">
						<div className="d-flex align-items-start mb-1">
							<div className="icon-md me-2 ">
								<Check className=" text-dark" />
							</div>
							<div>
								<p className="title-small mb-0">{t('t9')}</p>
								<p className="x-small text-muted">{t('t10')}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AlwaysIncluded;
